class CartSamples extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    ['onSubmitProductForm'].forEach((eventName) => {
      this[eventName] = this[eventName].bind(this);
    });
    this.removeManualSamples = this.dataset.removeManualSamples === 'true';
    this.timeout = null;
    this.samples = JSON.parse(this.dataset.samplesJson);
    this.cartTotalPrice = this.dataset.cartTotalPrice;
    this.cartIsValid = this.dataset.cartIsValid == '';
    this.maxCartLimitReached = this.dataset.maxCartLimitReached == '';
    this.cart = document.querySelector('cart-drawer');
    this.productFormEls = this.querySelectorAll('[data-product-form]');

    this.timeout = setTimeout(() => this.autoAddAndOrRemove(), 500);

    this.productFormEls.forEach((productFormEl) => {
      productFormEl.addEventListener('submit', this.onSubmitProductForm);
    });
  }

  disconnectedCallback() {
    clearTimeout(this.timeout);

    this.productFormEls.forEach((productFormEl) => {
      productFormEl.removeEventListener('submit', this.onSubmitProductForm);
    });
  }

  autoAddAndOrRemove() {
    const autoAddVariantIds = this.samples
      .filter((sample) => {
        return (
          this.cartIsValid &&
          !this.maxCartLimitReached &&
          sample.variant_in_stock &&
          sample.auto_add_enable &&
          sample.auto_add_cart_total_price_threshold != undefined &&
          !sample.is_in_cart &&
          this.cartTotalPrice >= sample.auto_add_cart_total_price_threshold
        );
      })
      .map((sample) => sample.variant.id);

    const autoRemoveVariantIds = this.samples
      .filter((sample) => {
        if (sample.is_in_cart && !sample.variant_in_stock) {
          return true;
        }

        if (sample.is_in_cart && !this.cartIsValid) {
          return true;
        }

        return (
          sample.auto_add_enable &&
          sample.auto_add_cart_total_price_threshold != undefined &&
          sample.is_in_cart &&
          this.cartTotalPrice < sample.auto_add_cart_total_price_threshold
        );
      })
      .map((sample) => sample.variant.id);

    const manualRemoveVariantIds = this.removeManualSamples
      ? this.samples
          .filter((sample) => !sample.auto_add_enable && sample.is_in_cart)
          .map((sample) => sample.variant.id)
      : [];

    if (autoAddVariantIds.length) {
      this.addToCart(undefined, autoAddVariantIds, false);
    }

    const allRemovals = [...new Set([...autoRemoveVariantIds, ...manualRemoveVariantIds])];
    if (allRemovals.length) {
      this.removeFromCart(allRemovals);
    }
  }

  onSubmitProductForm(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const form = button.closest('form');
    this.addToCart(form);
  }

  addToCart(formElement, variantIds = null, removable = true) {
    if (this.classList.contains('is-loading')) return;

    this.classList.add('is-loading');

    const sections = this.cart.getSectionsToRender().map((section) => section.id);
    const fetchUrl = `${window.routes.cart_add_url}.js`;

    const formData = new FormData();
    formData.set('sections', sections);

    const ids = variantIds && Array.isArray(variantIds)
      ? variantIds
      : Array.from(formElement.querySelectorAll('input[name="id"]')).map(input => input.value);
    ids.forEach((variantId, index) => {
      formData.append(`items[${index}][id]`, variantId);
      formData.append(`items[${index}][quantity]`, '1');
      formData.append(`items[${index}][properties][_sample]`, 'true');
      if (removable) {
        formData.append(`items[${index}][properties][_gwp-item-removable]`, 'true');
      }
    });

    const fetchOptions = {
      method: 'POST',
      body: formData
    };

    this.cart.open();
    this.cart.setLoading();

    fetch(fetchUrl, fetchOptions)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((res) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'vbb-cart-samples',
        });

        this.cart.renderContents(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.classList.remove('is-loading');

        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }

        this.cart.setNotLoading();
      });
  }

  removeFromCart(variantIds) {
    if (this.classList.contains('is-loading')) return;

    this.classList.add('is-loading');

    const sections = this.cart.getSectionsToRender().map((section) => section.id);

    const formData = new FormData();
    formData.set('sections', sections);

    variantIds.forEach((variantId) => {
      formData.append(`updates[${variantId}]`, 0);
    });

    const fetchUrl = `${window.routes.cart_update_url}.js`;

    const fetchOptions = {
      method: 'post',
      body: formData
    };

    this.cart.open();
    this.cart.setLoading();

    fetch(fetchUrl, fetchOptions)
      .then((res) => {
        if (!res.ok) {
          throw new Error();
        }

        return res.json();
      })
      .then((res) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'vbb-cart-samples',
        });

        this.cart.renderContents(res);

        if (res.item_count <= 0) {
          this.cart.classList.add('is-empty');
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.classList.remove('is-loading');
        this.cart.setNotLoading();
      });
  }
}

customElements.define('vbb-cart-samples', CartSamples);
